import { Drawer, Stack, Typography, Box, Button } from "@mui/material";
import React, { useState } from "react";
import { BaseUrl } from "../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import { toaststyle } from "../../Utils/toaststyle";

const AddCustomer = (props) => {
  const [Language, setLanguage] = useState("");
  const [lasName, setlasName] = useState("");
  const [Address, setAddress] = useState("");
  const [City, setCity] = useState("");
  const [address, setaddress] = useState("");
  const [company, setcompany] = useState("");
  const [Country, setCountry] = useState("");
  const [email, setemail] = useState("");
  const [facebook, setfacebook] = useState("");
  const [type, settype] = useState("");
  const [mobile, setmobile] = useState("");
  const [postalcode, setpostalcode] = useState("");
  const [state, setstate] = useState("");
  const [teams, setteams] = useState("");
  const [twitter, settwitter] = useState("");
  const [username, setusername] = useState("");
  const [whatsapp, setwhatsapp] = useState("");

  const AddContact = () => {
    if (username == "") {
      toast.warn("Username is Required", toaststyle);
      return;
    } 
    else if (mobile == "") {
      toast.warn("Phone Number is Required", toaststyle);
      return;
    }
    axios
      .post(
        BaseUrl + "/users/createcustomer",
        {
          language: Language,
          Lastname: lasName,
          address: Address,
          city: City,
          company: company,
          country: Country,
          email: email,
          facebookId: facebook,
          type: type,
          phonenumber: mobile,
          postalcode: postalcode,
          state: state,
          teamsId: teams,
          twitterId: twitter,
          username: username,
          whatsappnumber: whatsapp,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.status) {
          clearCatchData();
          props.setshowAddCustomer(false);
          toast.success(res.data.message, toaststyle);
          props.listContact();
        } else {
          clearCatchData();
          toast.error(res.data.message, toaststyle);
        }
      })
      .catch((err) => {});
  };

  const clearCatchData = () => {
    setLanguage("");
    setlasName("");
    setAddress("");
    setCity("");
    setcompany("");
    setCountry("");
    setemail("");
    setfacebook("");
    settype("");
    setmobile("");
    setpostalcode("");
    setstate("");
    setteams("");
    settwitter("");
    setusername("");
    setwhatsapp("");
  };

  return (
    <Drawer
      anchor="right"
      open={props.showAddCustomer}
      onClose={() => {
        props.setshowAddCustomer(false);
      }}
    >
      <Box
        sx={{
          width: "30rem",
        }}
      >
        {/* Drawer head start */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className="p-3 shadowDrawer"
        >
          <Typography variant="h3" gutterBottom className="drawer-title">
            Create Customer
          </Typography>
        </Stack>
        {/* Drawer head end */}
        {/* Drawer Content start */}
        <Stack style={{ height: "calc(100vh - 7rem)", overflowY: "scroll" }}>
          <form
            className="fillter_form2 CONTACT-LIST-AREA"
            style={{ height: "85vh", overflowY: "scroll", padding: "15px" }}
          >
            <div className="row row-cols-2">
              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">
                  Name <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control "
                  required
                  value={username}
                  onChange={(e) => {
                    setusername(e.target.value);
                  }}
                />
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">Lastname</label>
                <input
                  type="text"
                  className="form-control "
                  required
                  value={lasName}
                  onChange={(e) => {
                    setlasName(e.target.value);
                  }}
                />
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">
                  Email
                </label>
                <input
                  type="email"
                  className="form-control "
                  value={email}
                  onChange={(e) => {
                    setemail(e.target.value);
                  }}
                />
              </div>

              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">
                  Phone Number <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  maxLength="15"
                  type="text"
                  className="form-control "
                  required
                  value={mobile}
                  onChange={(e) => {
                    setmobile(e.target.value.replace(/[^\d]/, ""));
                  }}
                />
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">Type</label>
                <input
                  type="text"
                  className="form-control "
                  required
                  value={type}
                  onChange={(e) => {
                    settype(e.target.value);
                  }}
                />
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">Language</label>
                <input
                  type="text"
                  className="form-control "
                  value={Language}
                  onChange={(e) => {
                    setLanguage(e.target.value);
                  }}
                />
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">Address</label>
                <input
                  type="text"
                  className="form-control "
                  value={address}
                  onChange={(e) => {
                    setaddress(e.target.value);
                  }}
                />
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">Company</label>
                <input
                  type="text"
                  className="form-control "
                  value={company}
                  onChange={(e) => {
                    setcompany(e.target.value);
                  }}
                />
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">City</label>
                <input
                  type="text"
                  className="form-control "
                  value={City}
                  onChange={(e) => {
                    setCity(e.target.value);
                  }}
                />
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">State</label>
                <input
                  type="text"
                  className="form-control "
                  value={state}
                  onChange={(e) => {
                    setstate(e.target.value);
                  }}
                />
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">Postal Code</label>
                <input
                  type="text"
                  className="form-control "
                  value={postalcode}
                  onChange={(e) => {
                    setpostalcode(e.target.value);
                  }}
                />
              </div>
              <div className="mb-3 d-flex flex-column text-start">
                <label className="form-label">Country</label>
                <input
                  type="text"
                  className="form-control "
                  value={Country}
                  onChange={(e) => {
                    setCountry(e.target.value);
                  }}
                />
              </div>
            </div>
          </form>
        </Stack>
        {/* Drawer Content end */}
        {/* Drawer footer start */}
        <Stack
          className="p-2"
          sx={{
            position: "absolute",
            bottom: "0",
            background: "#f9f9f9",
            width: "100%",
            boxShadow:
              "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
          }}
          direction="row"
          justifyContent="space-between"
          alignContent="center"
        >
          <Button
            variant="contained"
            className="me-2 w-100"
            sx={{
              textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
              textTransform: "Capitalize",
            }}
            color="error"
            disableElevation
            onClick={() => {
              props.setshowAddCustomer(false);
            }}
          >
            Close
          </Button>
          <Button
            form="form1"
            className="w-100"
            variant="contained"
            disableElevation
            sx={{
              textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
              textTransform: "Capitalize",
            }}
            onClick={(e) => {
              AddContact(e);
            }}
            id="add_customer_Submit"
          >
            Create
          </Button>
        </Stack>
        {/* Drawer footer end */}
      </Box>
    </Drawer>
  );
};

export default AddCustomer;
